var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-not-found"},[_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("The page you're looking for doesn't exist.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }